import { createTheme } from '@mui/material/styles'

import { applyAppBarOverrides } from './applyAppBarOverrides'
import { applyButtonOverrides } from './applyButtonOverrides'
import { applyInputOverrides } from './applyInputOverrides'
import { applyPalette } from './applyPalette'
import { applyShape } from './applyShape'
import { applyTypography } from './applyTypography'

/**
 * Builds a customized MUI theme by piping the base theme through a series
 * of pure transformer functions, each applying one category of store settings.
 *
 * Pipeline order:
 * 1. Palette - establishes colors referenced by later transformers
 * 2. Typography - font families, independent but before component overrides
 * 3. Shape - global border radius
 * 4. Button overrides - may reference palette
 * 5. AppBar overrides - may reference palette
 * 6. Input overrides - variant defaults
 *
 * @param {import('@mui/material/styles').Theme} baseTheme - The base MUI theme (LightTheme or DarkTheme)
 * @param {Object|null} storeSettings - Store customization settings from API
 * @returns {import('@mui/material/styles').Theme} A fully resolved MUI theme
 */
const StoreThemeOverride = (baseTheme, storeSettings) => {
    let theme = baseTheme

    theme = applyPalette(theme, storeSettings)
    theme = applyTypography(theme, storeSettings)
    theme = applyShape(theme, storeSettings)
    theme = applyButtonOverrides(theme, storeSettings)
    theme = applyAppBarOverrides(theme, storeSettings)
    theme = applyInputOverrides(theme, storeSettings)

    return createTheme(theme)
}

export { StoreThemeOverride }
